<h1 mat-dialog-title>
    Filter Entries
    <mat-icon (click)="onClearFilters()" style="float: right;">close</mat-icon>
</h1>

<form [formGroup]="filterAppLogsForm" (ngSubmit)="onApplyFilters()">
    <div mat-dialog-content>
        <mat-card-content>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Module</mat-label>
                        <mat-select formControlName="module">
                            <ng-container *ngFor="let module_name of configurations?.modules">
                                <mat-option value="{{module_name.name}}">{{module_name.name}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Action</mat-label>
                        <mat-select formControlName="action">
                            <ng-container *ngFor="let action_name of configurations?.actions">
                                <mat-option value="{{action_name.name}}">{{action_name.name}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Level</mat-label>
                        <mat-select formControlName="level">
                            <ng-container *ngFor="let level_name of configurations?.levels">
                                <mat-option value="{{level_name.name}}">{{level_name.name}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>HTTP Method</mat-label>
                        <mat-select formControlName="http_method">
                            <ng-container *ngFor="let httpmethod of configurations?.http_methods">
                                <mat-option value="{{httpmethod.name}}">{{httpmethod.name}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Status Code</mat-label>
                        <mat-select formControlName="status_code">
                            <ng-container *ngFor="let statuscode of configurations?.status_codes">
                                <mat-option value="{{statuscode.name}}">{{statuscode.name}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <mat-form-field class="mb-25">
                        <mat-label>Created At</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="created_at">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </mat-card-content>
    </div>
    <div mat-dialog-actions style="justify-content: right;">
        <button mat-flat-button type="button" color="warn" (click)="onClearFilters()">Clear Filters</button>
        <button mat-flat-button type="button" color="warn" (click)="onDeleteFilter()" *ngIf="quickFilterData">Delete
            Filter</button>
        <button mat-flat-button type="submit" class="daxa">Apply Filters</button>
        <button *ngIf="showSaveBtn" mat-flat-button type="button" color="primary" (click)="onApplyAndSaveFilters()">Apply &amp; {{
            filterMode }} Filters</button>
    </div>
</form>

<!-- Loader Overlay -->
<div *ngIf="loading" class="export-overlay">
    <div class="spinner"></div>
</div>